module.exports = __webpack_public_path__ + "static/media/art61.f8aa43bb.jpg";